import React from 'react';
import tw from 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Container from '~components/Container';
import Hero from '~components/Hero';
import Heading from '~components/Heading';
import Callout from '~components/Callout';
import Text from '~components/Text';

import { fsbgimg, roundedImg } from '~theme';

const floatedImg = tw`float-left h-auto max-w-xs mr-4 mb-4 rounded-lg`;

const MemoriamPage: React.FC = () => (
  <Layout>
    <SEO title="In Memoriam: Liane Regendanz" desc="" />
    <Hero title="In Memoriam: Liane Regendanz">
      <StaticImage src="../images/old-picture-of-liane.jpg" alt="" style={fsbgimg} />
    </Hero>
    <Container>
      <Heading level="h2">Liane Regendanz</Heading>
      <Text tw="text-2xl">A life of compassion, community &amp; opportunity</Text>
      <Callout>
        <Text tw="my-0 text-2xl">
          It is with overwhelming sadness that we write of the passing of Liane Regendanz, former
          Executive Director of St. Stephen’s Community House. Liane’s impact on St. Stephen’s and
          all the people who came through our doors was profound.
        </Text>
      </Callout>
      <Text>
        For more than 30 years, Liane was integral to St. Stephen’s, and the surrounding community.
        She strove for equity and opportunity, first as manager of the Youth Employment Centre, then
        for 18 years as Executive Director.
      </Text>
      <Text>
        Liane’s leadership and passion for social justice spurred incredible innovation and growth
        including:
      </Text>
      <ul tw="list-inside list-disc text-xl">
        <li>
          The Augusta Centre Capital Campaign to renovate 260 Augusta Avenue for our Urban Health,
          Youth and Newcomer programs, as well as the development of the onsite L.L. Odette Place
          supportive housing
        </li>
        <li>
          Opening of the Senior’s Activity Centre, Waterfront Child Care Centre, North York Newcomer
          Centre and North York Conflict Resolution office
        </li>
      </ul>
      <Text>
        She was a pioneer of youth employment initiatives and innovative youth programming, the
        moving force behind L.L. Odette Place, and a real community activist, serving
        as past Chair of Toronto Neighbourhood Centres. On June 9, the City of Toronto issued a
        condolence motion and held a moment of silence in memory of Liane.
      </Text>
      <StaticImage src="../images/lianne.jpg" alt="" style={floatedImg} />
      <Text>
        Liane’s impact on the people who worked with her was just as great, and not just as a
        mentor. Her tireless energy inspired all of us to go the extra mile. Liane’s warmth and
        compassion helped her connect with the people we serve, and demonstrated to everyone that we
        are all equal.
      </Text>
      <Text>
        Oliva Chow once described Liane as a force of nature: Liane was driven to improve the lives
        of the city’s most vulnerable people. As a testament to her dedication and passion, in 2012
        Liane was the first recipient of the Frances Lankin Award, given to a person who made
        significant contributions to the Toronto non-profit sector. When she retired in 2015, a fund
        for youth was named in her honour:{' '}
        <a
          href="https://www.sschto.ca/Ways-to-Give/Liane-s-Fund"
          alt=""
          tw="text-purple-900 underline"
        >
          Liane’s Fund for Youth Opportunity
        </a>
        .
      </Text>
      <Text>
        In her retirement, Liane lived life to the fullest, fueling her passions and seeing the
        world. That world, and the world of all those she touched, is forever lessened without her.
      </Text>
      <div tw="flex space-x-6">
        <StaticImage src="../images/lianne-bald-with-friend.jpg" alt="" style={roundedImg} />
        <StaticImage src="../images/liane-with-group.jpg" alt="" style={roundedImg} />
      </div>
    </Container>
  </Layout>
);

export default MemoriamPage;
